import { axiosConfig } from './axios'
import { carouselConfig } from './carousel'
import routes from './routes'

const config = {
  routes,
  axios: axiosConfig,
  carousel: carouselConfig
}

export default config
